import { Outlet } from "react-router-dom";

export default function Credentials(props: any) {
  return (
    <div className="Credentials">
      <Outlet />
    </div>
  );
}
